export default function reducer(
  state = {
    fetching: false,
    fetched: false,
    error: null,
    orders: [],
    totalItems: 0,
  },
  action,
) {
  switch (action.type) {
    case "FETCH_BULK_ORDER_LOG_PENDING": {
      return {
        ...state,
        fetching: true,
        fetched: false,
      };
    }
    case "FETCH_BULK_ORDER_LOG_REJECTED": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.payload,
      };
    }
    case "FETCH_BULK_ORDER_LOG_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        orders: action.payload.data,
        error: null,
      };
    }
    case "FETCH_BULK_ORDER_LOG_TOTAL_PENDING": {
      return {
        ...state,
        fetchingTotal: true,
      };
    }
    case "FETCH_BULK_ORDER_LOG_TOTAL_REJECTED": {
      return {
        ...state,
        fetchingTotal: false,
        error: action.payload,
      };
    }
    case "FETCH_BULK_ORDER_LOG_TOTAL_FULFILLED": {
      const totalData = action.payload.data || [];
      return {
        ...state,
        fetchingTotal: false,
        totalItems: Array.isArray(totalData) ? totalData.length : 0,
        error: null,
      };
    }

    case "RESET_STATE": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: null,
      };
    }

    default: {
      return { ...state };
    }
  }
}
